"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailToolbarButtonMenu = void 0;
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const Divider_1 = __importDefault(require("@material-ui/core/Divider"));
const ListItemIcon_1 = __importDefault(require("@material-ui/core/ListItemIcon"));
const ListItemText_1 = __importDefault(require("@material-ui/core/ListItemText"));
const Menu_1 = __importDefault(require("@material-ui/core/Menu"));
const MenuItem_1 = __importDefault(require("@material-ui/core/MenuItem"));
const ExpandMore_1 = __importDefault(require("@material-ui/icons/ExpandMore"));
const tooltip_1 = require("../../components/tooltip/tooltip");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const detail_styles_1 = require("./detail-styles");
const detail_types_1 = require("./detail-types");
function DetailToolbarButtonMenu({ label, tooltip, disabled, type = detail_types_1.DetailToolbarButtonType.NORMAL, items, startIcon, ...restProps }) {
    const classes = (0, detail_styles_1.useStyles)();
    const buttonProps = { ...restProps };
    if (type === detail_types_1.DetailToolbarButtonType.PRIMARY) {
        buttonProps.color = 'primary';
        buttonProps.variant = 'contained';
        buttonProps.classes = { root: classes.toolbarMainButton };
    }
    else if (type === detail_types_1.DetailToolbarButtonType.SECONDARY) {
        buttonProps.color = 'secondary';
        buttonProps.variant = 'contained';
        buttonProps.classes = { root: classes.toolbarMainButton };
    }
    const anchorRef = (0, react_1.useRef)(null);
    const [opened, setOpened] = (0, react_1.useState)(false);
    const openMenu = (0, event_callback_hook_1.useEventCallback)(() => {
        setOpened(true);
    });
    const closeMenu = (0, event_callback_hook_1.useEventCallback)(() => {
        setOpened(false);
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(tooltip_1.Tooltip, { title: tooltip, placement: "top-start" },
            react_1.default.createElement(Button_1.default, { ref: anchorRef, onClick: openMenu, disabled: disabled, classes: { root: classes.toolbarButton }, ...buttonProps, variant: "outlined", startIcon: startIcon, endIcon: react_1.default.createElement(ExpandMore_1.default, null) }, label)),
        react_1.default.createElement(Menu_1.default, { getContentAnchorEl: null, anchorEl: anchorRef.current, open: opened, onClose: closeMenu, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'right',
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'right',
            }, MenuListProps: {
                disablePadding: true,
            } }, items.map((item, i) => (react_1.default.createElement(Item, { item: item, key: i, onClose: closeMenu }))))));
}
exports.DetailToolbarButtonMenu = DetailToolbarButtonMenu;
const Item = (0, react_1.forwardRef)(function Item({ item: { label, tooltip, onClick, href, Icon, divider, warning }, onClose, }, ref) {
    const classes = (0, detail_styles_1.useStyles)();
    const handleClick = (0, event_callback_hook_1.useEventCallback)(() => {
        onClick();
        onClose();
    });
    return divider ? (react_1.default.createElement(Divider_1.default, null)) : (react_1.default.createElement(tooltip_1.Tooltip, { title: tooltip, placement: "right-start" },
        react_1.default.createElement(MenuItem_1.default, { ref: ref, component: Button_1.default, onClick: handleClick, href: href, className: (0, clsx_1.default)(classes.toolbarButton, classes.toolbarButtonMenu, {
                [classes.toolbarButtonWarning]: warning,
            }) },
            Icon && react_1.default.createElement(ListItemIcon_1.default, null, Icon),
            react_1.default.createElement(ListItemText_1.default, { primary: label }))));
});
//# sourceMappingURL=detail-toolbar-button-menu.js.map